<template>
  <div>
    <Toolbar4 />
    <FaqMain />
    <Footer4Entry />
  </div>
</template>

<script>
import Toolbar4 from '@/components/ui/landing/toolbar/Toolbar4.vue'
import FaqMain from '@/components/ui/faq/FaqMain.vue'
import Footer4Entry from '@/components/ui/landing/footer/Footer4Entry.vue'

export default {
  components: {
    Toolbar4,
    FaqMain,
    Footer4Entry

  }
}
</script>